// Professional mock data for doctor portfolio

export const doctorData = {
  name: "Dr. Vinayak Sagar",
  specialization: "Neuropsychiatrist",
  experience: 15,
  phone: "+1 (555) 123-4567",
  email: "dr.vinayaksagar@healthcare.com",
  introduction:
    "Dedicated to providing compassionate, patient-centered care with over 15 years of experience in Neuropsychiatry. I specialize in the diagnosis and treatment of disorders affecting the brain and behavior, focusing on holistic mental and neurological wellness.",

  expertise: [
    "Neuropsychiatric Evaluation",
    "Cognitive Behavioral Therapy",
    "Dementia & Memory Disorders",
    "Mood & Anxiety Disorders",
    "Sleep Medicine",
    "Brain Injury Rehabilitation",
  ],

  education: [
    {
      degree: "Doctor of Medicine (MD) in Psychiatry",
      institution: "Osmania Medical College, Hyderabad",
      year: "2009",
    },
    {
      degree: "MBBS",
      institution: "Osmania Medical College, Hyderabad",
      year: "2005",
    },
    {
      degree: "Fellowship in Neuropsychiatry",
      institution: "NIMHANS, Bangalore",
      year: "2012",
    },
  ],

  experience_history: [
    {
      role: "Senior Neuropsychiatrist",
      organization: "Apollo Hospitals, Hyderabad",
      duration: "2015 - Present (9 years)",
    },
    {
      role: "Consultant Psychiatrist",
      organization: "Fortis Hospital, Kondapur, Hyderabad",
      duration: "2012 - 2015 (3 years)",
    },
    {
      role: "Resident in Psychiatry",
      organization: "Institute of Mental Health, Hyderabad",
      duration: "2009 - 2012 (3 years)",
    },
  ],

  services: [
    {
      title: "Neuropsychiatric Assessment",
      description:
        "Comprehensive evaluation of cognitive, behavioral, and emotional functioning",
    },
    {
      title: "Psychotherapy Sessions",
      description: "Evidence-based counseling and therapeutic interventions",
    },
    {
      title: "Memory Clinic",
      description:
        "Specialized care for Alzheimer's, dementia, and memory-related concerns",
    },
    {
      title: "Sleep Disorder Treatment",
      description:
        "Diagnosis and management of insomnia, apnea, and other sleep issues",
    },
    {
      title: "Mood Disorder Management",
      description:
        "Specialized care for depression, bipolar disorder, and anxiety",
    },
    {
      title: "Headache & Migraine Clinic",
      description:
        "Advanced treatment protocols for chronic headaches and migraines",
    },
  ],

  clinic: {
    name: "Sagar Family Healthcare Center",
    address:
      "Plot No. 123, Sri Sai Plaza, Dilsuknagar, Hyderabad, Telangana 500060, India",
    timings: [
      { days: "Monday - Friday", hours: "9:00 AM - 6:00 PM" },
      { days: "Saturday", hours: "10:00 AM - 2:00 PM" },
      { days: "Sunday", hours: "Closed" },
    ],
  },

  testimonials: [
    {
      name: "Rajesh Malhotra",
      age: 68,
      text: "Dr. Sagar has been my physician for 8 years. He is thorough, patient, and always takes time to explain everything clearly. I trust him completely with my health.",
    },
    {
      name: "Sunita Sharma",
      age: 55,
      text: "Excellent doctor! He helped me manage my diabetes and blood pressure. His caring approach made all the difference. Highly recommend!",
    },
    {
      name: "Amit Patel",
      age: 72,
      text: "Professional, knowledgeable, and compassionate. Dr. Sagar listens to concerns and provides practical solutions. Best doctor I've had in years.",
    },
  ],
};
